import { useLocalStorage } from "@apac/hooks";
import { ExperimentVariant } from "@hopper-b2b/types";
import { useFeatureFlag } from "./useFeatureFlag";

const prefix = "feature-flag--";

export const useCachedFeatureFlag = (
  expName: string,
  options: {
    fallback?: boolean;
    variant?: ExperimentVariant;
  } = {}
): boolean => {
  const { variant = ExperimentVariant.Available, fallback = false } = options;
  const flag = useFeatureFlag(expName, variant, true);
  const [cachedValue, setCachedValue] = useLocalStorage<boolean | undefined>(
    `${prefix}${expName}`,
    undefined
  );
  if (cachedValue !== flag) {
    setCachedValue(flag);
    return flag ?? fallback;
  }
  return cachedValue == null ? fallback : cachedValue;
};
